import { useMemo, Fragment } from 'react'
import { useBlockEngine } from '../blocks-core/BlockEngineContext'

/**
 * Hook to render child blocks from BlockEngine by their IDs
 * Works recursively for nested containers
 *
 * @param childBlockIds - Array of child block IDs to render
 * @returns Array of React nodes or null if no children
 */
export const useBlockChildren = (childBlockIds?: string[]): React.ReactNode[] | null => {
    const { blockEngine } = useBlockEngine()

    return useMemo(() => {
        if (!childBlockIds || childBlockIds.length === 0) {
            return null
        }

        const children = childBlockIds
            .map(id => {
                const block = blockEngine.getBlock(id)
                if (!block) {
                    console.warn(`Child block ${id} not found in engine`)
                    return null
                }
                return <Fragment key={id}>{block.getElement()?.element}</Fragment>
            })
            .filter(Boolean) as React.ReactNode[]

        return children.length > 0 ? children : null
    }, [childBlockIds, blockEngine])
}
